<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>账号</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a @click="backHref">三方渠道</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section
      v-show="!isHideDetails && !addHideIs && !editHideIs && !hideInAddShow"
    >
      <section class="searchBox">
        <span class="addStyle">
          <a-button type="primary" icon="plus" @click="addHideIs = !addHideIs"
            >增加</a-button
          >
        </span>
        <span>
          <label>类型：</label>
          <a-radio-group v-model="type">
            <a-radio :value="1">公司</a-radio>
            <a-radio :value="2">个人</a-radio>
          </a-radio-group>
        </span>
        <span>
          <label>状态：</label>
          <a-radio-group v-model="sign_status">
            <a-radio :value="2">已签约</a-radio>
            <a-radio :value="1">未签约</a-radio>
          </a-radio-group>
        </span>
        <span>
          <label>字符串：</label>
          <a-input
            style="width: 210px"
            placeholder="公司名称|联系人姓名|手机号"
            v-model="query_field"
          />
        </span>
        <span>
          <a-button @click="onReset">重置</a-button
          ><a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
          <a-button @click="onDownload" class="resetStyle">
            <a-icon type="vertical-align-bottom" />下载
          </a-button>
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <table>
          <thead>
            <tr>
              <th v-for="item in thList" :key="item">{{ item }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.length < 1">
              <td></td>
              <td></td>
              <td></td>
              <td>暂无</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-show="data.length > 0" v-for="(item, i) in data" :key="i">
              <td>
                <p v-show="item.type == 1">公司</p>
                <p v-show="item.type == 2">个人</p>
              </td>
              <td>{{ item.name }}</td>
              <td>{{ item.contact_name }}</td>
              <td>{{ item.contact_phone }}</td>
              <td>{{ item.entry_count }}</td>
              <td>
                {{
                  item.project_names == ""
                    ? 0
                    : item.project_names.split(",").length
                }}
              </td>
              <td class="operation">
                <a @click="detailsPage(item)" style="color: #909399">详情</a>
                <a @click="editPage(item)" style="color: #67C23A">编辑</a>
                <a
                  v-show="
                    item.type == 1 || (item.type == 2 && item.entry_count == 0)
                  "
                  @click="addPage(item)"
                  >开通账号</a
                >
              </td>
            </tr>
          </tbody>
        </table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- 增加 -->
    <addThirdParty v-if="addHideIs" v-on:hideInAdd="hideInAdd" />
    <!-- 增加 end-->
    <!-- 编辑 -->
    <thirdPartyEdit
      v-show="editHideIs"
      :editDetail="editDetail"
      v-on:hideInEdit="hideInEdit"
    />
    <!-- 编辑  end-->
    <!-- 详情 -->
    <thirdDetails v-if="isHideDetails" :thirdDetailsVal="thirdDetailsVal" />
    <!-- 详情 end -->

    <!-- 增加 -->
    <addChannelAccount
      :channelAccountDetail="channelAccountDetail"
      v-on:hideInAddAccount="hideInAddAccount"
      v-if="hideInAddShow"
    />
    <!-- 增加 end-->
  </div>
</template>
<script>
import axios from "axios";
import addThirdParty from "@/components/resume/addThirdParty.vue";
import thirdPartyEdit from "@/components/resume/thirdPartyEdit.vue";
import thirdDetails from "@/components/resume/thirdDetails.vue";
import addChannelAccount from "@/components/resume/addChannelAccount"; //增加用户
export default {
  data() {
    return {
      data: [],
      loading: false,
      page: 1,
      pagination: {},
      thList: [
        "类型",
        "公司名称",
        "联系人姓名",
        "联系人电话",
        "账号数",
        "合作项目数",
        "操作"
      ],
      isHideDetails: false,
      details: {},
      query_field: "",
      addHideIs: false,
      editHideIs: false,
      editDetail: "",
      thirdDetailsVal: {},
      type: "",
      sign_status: "",
      hideInAddShow: false,
      channelAccountDetail: ""
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {
    addThirdParty,
    thirdPartyEdit,
    thirdDetails,
    addChannelAccount
  },
  mounted() {
    this.getData(); //获取列表
  },
  methods: {
    hideInAddAccount() {
      this.hideInAddShow = false;
      this.reload();
    },
    addPage(item) {
      if (item.type == 1) {
        this.hideInAddShow = true;
        this.channelAccountDetail = item;
      } else {
        let _this = this;
        this.$confirm({
          title: "开通账号",
          content: "是否确定为" + item.contact_name + "开通账号",
          cancelText: "取消",
          okText: "确认",
          onOk() {
            _this.httpsAddAccount(item);
          },
          onCancel() {}
        });
      }
    },
    httpsAddAccount(item) {
      console.log(item);
      let url =
        this.httpsBasic.url +
        this.httpsBasic.user +
        "User/addPersonChannelUser";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          third_part_id: item.id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success("新增成功");
            this.reload();
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    onDownload() {
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "Third_part/thirdPartListDownload?token=" +
        window.localStorage.getItem("xnwfPcToken") +
        "&sign_status=" +
        this.sign_status +
        "&type=" +
        this.type +
        "&query_field=" +
        this.query_field;
    },
    onReset() {
      this.sign_status = "";
      this.type = "";
      this.query_field = "";
      this.page = 1;
      this.getData();
    },
    detailsPage(item) {
      this.thirdDetailsVal = item;
      this.isHideDetails = true;
    },
    hideInAdd(isHide) {
      this.addHideIs = isHide;
      this.reload();
    },
    hideInEdit(isHide) {
      this.editHideIs = isHide;
      this.reload();
    },
    backHref() {
      this.isHideDetails = false;
      this.addHideIs = false;
      this.editHideIs = false;
      this.hideInAddShow = false;
    },
    onChangeDate(date, dateString) {
      this.start_date = dateString[0];
      this.end_date = dateString[1];
      //  console.log(this.searchDate);
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      let url =
        this.httpsBasic.url +
        this.httpsBasic.resume +
        "Third_part/thirdPartList";
      axios
        .post(url, {
          current_page: this.page,
          per_page: 10,
          query_field: this.query_field,
          sign_status: this.sign_status,
          type: this.type,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            // console.log(res);
            this.data = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    delectPage(val) {
      const self = this;
      this.$confirm({
        title: "删除第三方公司?",
        content: "一旦删除无法恢复，请谨慎操作!",
        okText: "确定",
        cancelText: "取消",
        onOk() {
          let url =
            self.httpsBasic.url +
            self.httpsBasic.resume +
            "Third_part/removeThirdPart";
          axios
            .post(url, {
              token: window.localStorage.getItem("xnwfPcToken"),
              id: val.id
            })
            .then(res => {
              if (res.data.code == 200) {
                self.$message.success("删除成功");
                this.reload();
              } else {
                self.$message.warning(res.data.message);
              }
            })
            .catch(err => {
              self.$message.error("服务器出错啦...");
            });
        },
        onCancel() {}
      });
    },
    editPage(val) {
      this.editHideIs = true;
      this.editDetail = val;
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);
.listContainer {
  .searchBox {
    padding: 14px 2%;
    display: block;
    > span {
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 10px;
      button {
        margin-left: 10px;
      }
    }
  }
}
</style>
